import {
  GET_LIST_DUNOGIAONHANVIEN,
  GET_LIST_DUNOGIAONHANVIEN_SUCCESS,
  GET_LIST_DUNOGIAONHANVIEN_FAILURE,
} from "../../actions/DuNoGiaoNhanVien/actionTypes";

const initialState = {
  List: [],
  TongDuNo: 0,
  TongHopDong: 0,
  TongBanGhi: 0,
};
const getListDuNoGiaoNhanVien = (state, action) => ({
  ...state,
  getListDuNoGiaoNhanVienLoading: true,
});

const getListDuNoGiaoNhanVienSuccess = (state, action) => {
  return {
    ...state,
    List: action.payload.List,
    TongDuNo: action.payload.TongDuNo,
    TongHopDong: action.payload.TongHopDong,
    TongBanGhi: action.payload.TongBanGhi,
    getListDuNoGiaoNhanVienLoading: false,
  };
};

const getListDuNoGiaoNhanVienFailed = (state, action) => ({
  ...state,
  getListDuNoGiaoNhanVienLoading: false,
  List: [],
});
export const listDuNoGiaoNhanVienReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_DUNOGIAONHANVIEN:
      return getListDuNoGiaoNhanVien(state, action);
    case GET_LIST_DUNOGIAONHANVIEN_SUCCESS:
      return getListDuNoGiaoNhanVienSuccess(state, action);
    case GET_LIST_DUNOGIAONHANVIEN_FAILURE:
      return getListDuNoGiaoNhanVienFailed(state, action);
    default:
      return state;
  }
};

export default listDuNoGiaoNhanVienReducer;
